import { authPpiApiAxiosWithRefresh } from './api';

export interface ResearchReport {
    id: string;
    created_at: string;
    name: string;
}

export const getResearchReports = async (): Promise<ResearchReport[]> => {
    try {
        const response = await (await authPpiApiAxiosWithRefresh()).get('/get_research_reports');
        return response.data;
    } catch (error) {
        console.error('Error fetching Research reports:', error);
        return [];
    }
};
